import mixpanel from 'mixpanel-browser';
import { useEffect } from 'react';

import Router from './routes';
import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import useAuth from './hooks/useAuth';
import useCarbonUser from './hooks/useCarbonUser';
import useMerchant from './hooks/useMerchant';
import { getCountryName } from './utils/countryData';
import { PageContextProvider } from 'src/contexts/PageContext';
import { SettingsTlpContextProvider } from './contexts/SettingsTlpContext';
// import { appcuesIdentifyMerchant, appcuesIdentifyUser, appcuesTrackEvent } from "./utils/appcues";
import NoInternetConnection from './pages/NoInternetConnection';
import { ActivityCalculatorSettingsContextProvider } from "./contexts/ActivityCalculatorSettingsContext";
import { CartContextProvider } from './contexts/CartContext';
import { DateFilterProvider } from './contexts/DateFilterContext';
import { updateUserAPI } from './resources/api/customers/index.api';
import './base.css';

//
//

export default function App() {
  const { user, isAuthenticated } = useAuth();
  const { getCarbonUser, carbonUser } = useCarbonUser();
  const { merchant } = useMerchant();

  useEffect( () => {
    if (user?.email && isAuthenticated) {
      getCarbonUser(user?.email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, user?.email, user?.name]);

  useEffect(() => {
    if (user?.name && merchant && carbonUser?.id) {
      //sets the current user identifier, so subsequent events are associated to the correct user in MixPanel
      mixpanel.identify(`${merchant?.code}-${carbonUser.id}`);

      //'updates' the user's information in MixPanel
      mixpanel.people.set({
        $email: user.email,
        $name: user?.name,
        $merchant_country: getCountryName(merchant.country),
        $merchant_name: merchant.name,
        $merchant_code: merchant.code
      });
      // appcuesIdentifyUser(carbonUser?.id, user);
      // appcuesIdentifyMerchant(merchant?.id, merchant);
      // appcuesTrackEvent("user_logged_in");

      //hubspot identify user
      // @ts-ignore
      window._hsq?.push(["identify", { email: user.email }]);
      // @ts-ignore
      window._hsq?.push(['setPath', window.location.pathname]);
      // @ts-ignore
      window._hsq?.push(['trackPageView']);
    }
  }, [merchant, user?.name, user?.email, carbonUser, user]);

  useEffect(() => {
    if (user?.email) {
      updateUserAPI(user.email, true)
    }
  }, [user?.email])

  return (
  <NoInternetConnection>
    <PageContextProvider>
      <MotionLazyContainer>
            <NotistackProvider>
                <DateFilterProvider>
                <CartContextProvider>
                  <SettingsTlpContextProvider>
                    <ActivityCalculatorSettingsContextProvider>
                        <ProgressBarStyle />
                        <ChartStyle />
                        <ScrollToTop />
                        <Router />
                    </ActivityCalculatorSettingsContextProvider>
                  </SettingsTlpContextProvider>
                </CartContextProvider>
                </DateFilterProvider>
            </NotistackProvider>
      </MotionLazyContainer>
    </PageContextProvider>
  </NoInternetConnection>
  );
}